/**
 * Returns the Indian financial year suffix.
 * Previously returned "/YY-YY" but now returns empty string
 * to remove FY suffix from all document numbers globally.
 */
export function getFinancialYearSuffix(_date: Date = new Date()): string {
  const month = _date.getMonth(); // 0-indexed, April = 3
  const year = _date.getFullYear();
  const startYear = month >= 3 ? year : year - 1;
  const endYear = startYear + 1;
  const s = String(startYear % 100).padStart(2, '0');
  const e = String(endYear % 100).padStart(2, '0');
  return `-${s}${e}`;
}

/**
 * Returns the start and end dates of the current Indian financial year.
 * Indian FY runs from April 1 to March 31.
 */
export function getCurrentFYRange(date: Date = new Date()): { start: string; end: string } {
  const month = date.getMonth(); // 0-indexed, so April = 3
  const year = date.getFullYear();
  const fyStartYear = month >= 3 ? year : year - 1;
  return {
    start: `${fyStartYear}-04-01`,
    end: `${fyStartYear + 1}-03-31`,
  };
}
